import { TypographyName } from '@zapier/design-system';

export type ScreenSize =
  | 'all'
  | 'extraSmall'
  | 'small'
  | 'medium'
  | 'large'
  | 'extraLarge';

export const BREAKPOINTS = {
  extraSmall: 450,
  small: 640,
  medium: 768,
  large: 1024,
  extraLarge: 1280,
};
export const MIN_WIDTH = {
  extraSmall: `(min-width: ${BREAKPOINTS.extraSmall}px)`,
  small: `(min-width: ${BREAKPOINTS.small}px)`,
  medium: `(min-width: ${BREAKPOINTS.medium}px)`,
  large: `(min-width: ${BREAKPOINTS.large}px)`,
  extraLarge: `(min-width: ${BREAKPOINTS.extraLarge}px)`,
};

export const MAX_WIDTH = {
  extraSmall: `(max-width: ${BREAKPOINTS.extraSmall}px)`,
  small: `(max-width: ${BREAKPOINTS.small}px)`,
  medium: `(max-width: ${BREAKPOINTS.medium}px)`,
  large: `(max-width: ${BREAKPOINTS.large}px)`,
  extraLarge: `(max-width: ${BREAKPOINTS.extraLarge}px)`,
};

export const MEDIA_MAX_WIDTH = {
  extraSmall: `@media ${MAX_WIDTH.extraSmall}`,
  small: `@media ${MAX_WIDTH.small}`,
  medium: `@media ${MAX_WIDTH.medium}`,
  large: `@media ${MAX_WIDTH.large}`,
  extraLarge: `@media ${MAX_WIDTH.extraLarge}`,
};

export const MEDIA_MIN_WIDTH = {
  extraSmall: `@media ${MIN_WIDTH.extraSmall}`,
  small: `@media ${MIN_WIDTH.small}`,
  medium: `@media ${MIN_WIDTH.medium}`,
  large: `@media ${MIN_WIDTH.large}`,
  extraLarge: `@media ${MIN_WIDTH.extraLarge}`,
};

export const mediaQueryValues = {
  tablet: `(min-width: 768px)`,
  desktop: `(min-width: 1230px)`,
};

export const mediaQueries = {
  tablet: `@media ${mediaQueryValues.tablet}`,
  desktop: `@media ${mediaQueryValues.desktop}`,
};

export type HeadingSize = 'small' | 'medium' | 'large';

export const HEADING_SIZE_MAP: Record<
  HeadingSize,
  Record<'mobile' | 'tablet' | 'desktop', TypographyName>
> = {
  small: {
    mobile: 'subHeader5Bold',
    tablet: 'pageHeader9',
    desktop: 'pageHeader7',
  },
  medium: {
    mobile: 'pageHeader9',
    tablet: 'pageHeader7',
    desktop: 'pageHeader5',
  },
  large: {
    mobile: 'pageHeader7',
    tablet: 'pageHeader5',
    desktop: 'pageHeader3',
  },
};

export const SUB_HEADING_SIZE_MAP: Record<
  HeadingSize,
  Record<'mobile' | 'tablet' | 'desktop', TypographyName>
> = {
  small: {
    mobile: 'paragraph3',
    tablet: 'paragraph3',
    desktop: 'paragraph1',
  },
  medium: {
    mobile: 'paragraph3',
    tablet: 'paragraph1',
    desktop: 'subHeader5',
  },
  large: {
    mobile: 'paragraph1',
    tablet: 'subHeader5',
    desktop: 'subHeader3',
  },
};
